import {createSlice} from '@reduxjs/toolkit';
import {IRequestLoggerState} from 'modules/request-logger/types';
import {HYDRATE} from 'next-redux-wrapper';

export const requestLoggerModuleName = 'requestLogger';

const initialState: IRequestLoggerState = {
    log: [],
    pathname: '',
};

export const requestLoggerSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE as any, (state, action: any) => {
            if (!action?.payload) {
                return state;
            }

            return action.payload[requestLoggerModuleName];
        });
    },
    initialState,
    name: requestLoggerModuleName,
    reducers: {
        actionSetPathname(state, {payload}: {payload: string}) {
            state.pathname = payload;
        },
    },
});

export const {
    reducer: requestLoggerReducer,
    actions: {actionSetPathname},
} = requestLoggerSlice;
